var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "app-header app-pr" }, [
    _c("div", { staticClass: "left-box" }, [
      _c("div", {
        staticClass: "persion app-header-user app-mr10",
        on: {
          click: function($event) {
            return _vm.showUserDialog(true)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "logo-box", on: { click: _vm.toHome } }, [
      _c("div", { staticClass: "logo app-fl" }),
      _vm._v(" "),
      _c("div", { staticClass: "text app-fl" }, [_vm._v("首页")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right-box" }, [
      _c("div", {
        staticClass: "menu app-header-menu",
        on: {
          click: function($event) {
            return _vm.showDialog(true)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "menuDialog",
        staticClass: "header-dialog app-pa",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "sanjiao" }),
        _vm._v(" "),
        _c("div", { staticClass: "menu-list" }, [
          _c("ul", [
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("cardCenter")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left1" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            代金券中心\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("personalBill")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left2" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            个人账单\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("giftReceipt")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left3" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            签收中心\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("displayActions")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left4" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            陈列活动\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("dealerGrade", { role: "Dealer" })
                  }
                }
              },
              [
                _c("div", { staticClass: "left left5" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            配送评价\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("salesGrade", { role: "Sales" })
                  }
                }
              },
              [
                _c("div", { staticClass: "left left6" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            业代评价\n          ")
                ])
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", {
      ref: "userDialog",
      staticClass: "header-dialog header-user-dialog app-pa",
      staticStyle: { display: "none" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b716a152", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b716a152","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appHeader/App-header.vue
// module id = null
// module chunks = 